"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COLOR_SCHEME_ISOLATION_GATE = void 0;
const COLOR_SCHEME_ISOLATION_GATE = exports.COLOR_SCHEME_ISOLATION_GATE = 'LiveChat:ColorSchemeIsolation';